<template>
  <div id="app">
    <game-open></game-open>
  </div>
</template>

<script>
// OGP タグをサーバサイドで書き出すためにAppを個別に作成
import GameOpen from '@/pages/game/open/index.vue'

export default {
  name: 'app',
  components: {
    GameOpen
  }
}
</script>

<style src="./app.css">
</style>
